import React from "react";
import { Box } from "@mui/material";
import WorkspacePage from "./WorkspacePage";
import PageHeader from "./PageHeader";
import StyledDataGrid from "./StyledDataGrid";

const ListPageLayout = ({ title, headerActions, filters, gridProps, gridTourId }) => (
  <WorkspacePage>
    <PageHeader title={title} actions={headerActions} />
    {filters}
    <Box sx={{ flex: 1, minHeight: 0, width: "100%" }} data-tour-id={gridTourId}>
      <StyledDataGrid disableSelectionOnClick {...gridProps} />
    </Box>
  </WorkspacePage>
);

export default ListPageLayout;